const API_BASE_URL = process.env.REACT_APP_API_URL || "https://app.webyappy.com/webyappy-api/index.php";

export default API_BASE_URL;
